/* eslint-disable react/prop-types */
import React from 'react';
import { useFormikContext } from 'formik';

import TimePicker from '@components/form/TimePicker';
import SociollaErrorMessage from './SociollaErrorMessage';

function SociollaTimePicker({ name, subName = '', onChange, ...otherProps }) {
  const { setFieldValue, errors, touched, values } = useFormikContext();

  let finalName = name;
  if (subName) {
    finalName = `${name}.${subName}`;
  }

  let finalValue = values[name];
  if (subName) {
    finalValue = finalValue[subName];
  }

  return (
    <>
      <TimePicker
        onChange={async (value) => {
          await setFieldValue(finalName, value);
          if (onChange) {
            onChange(value);
          }
        }}
        value={finalValue}
        name={finalName}
        {...otherProps}
      />
      <SociollaErrorMessage
        error={errors[finalName]}
        visible={touched[finalName]}
      />
    </>
  );
}

export default SociollaTimePicker;
